import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=35422960&scoped=true"
import script from "./TagsInput.vue?vue&type=script&lang=js"
export * from "./TagsInput.vue?vue&type=script&lang=js"
import style0 from "./TagsInput.vue?vue&type=style&index=0&id=35422960&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35422960",
  null
  
)

export default component.exports